import { Breadcrumb, Card, Col, EventHandler, Row, SofturaTable } from "client/CommonComponents";
import excel from '../../../../assets/images/Excel.svg';
import { FilteringMode } from 'ka-table/enums';
import { useNavigate } from "react-router-dom";

const ComplianceAuditReport = (props: any) => {
    const {
        breadcrumlist,
        approvalHierarchyColumns,
        complianceModificationReport,
        approvalListAssignement,
        hierarchyModificationColumns,
        modificationServerTotal,
        approverUpdateServerTotal,
        approverUpdatesGridData,
        onAuditExportExcel,
        showAuditGrid,
        isMyOrdersGridLoading
    } = props
    const navigate = useNavigate();

    return (
        <div className='Approval-Dashboard mt-1'>
            <div className='breadCrumbBlock'>
                <button className='backButton mb-sm-2 mb-3' onClick={() => { navigate("/ordermanagement/approval") }} data-attribute="ComplianceAuditReport_Default_Button">
                    <span className="fa fa-chevron-left"></span>&nbsp;
                    Back
                </button>
                <div className="breadcrumbList">
                    <div className='order-1'><Breadcrumb items={breadcrumlist} maxDisplayedItems='5'  data-attribute="ComplianceAuditReport_Default_Breadcrumb" /></div>
                </div>
            </div>
            <Card data-attribute="ComplianceAuditReport_Default_Card">
                <div className="row">
                    <div className='penalityHeader margin-bottom-heading'>
                        <p className='headingText pull-left'>Compliance Audit Detail</p>
                    </div>
                </div>
                <Row className="top-section">
                    <Col xs={12} sm={12} md={12} lg={12}>
                        <Row>
                            <Col xs={6} sm={6} md={6} lg={6}>
                                <p>Original Hierarchy Structure</p>
                            </Col>
                            <Col xs={6} sm={6} md={6} lg={6}>
                                <div className='mb-1 top-section approval-hierarchy'>
                                    <div className='clearfix mb-3'>
                                        <div className='btn-block-approvalhierarchy pull-right'>
                                            <div className={`excel-section-approvalhierarchy mt-1 ${showAuditGrid ? "" : "disable-export-excel"}`}>
                                                <EventHandler onEvent={onAuditExportExcel} data-attribute="ComplianceAuditReport_Default_EventHandler">
                                                    <img
                                                        src={excel}
                                                        alt='excel'
                                                    />
                                                </EventHandler>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>

                    <div className={`pe-0 ${approvalListAssignement?.length != 0 ? "softura-table" : "softura-table paginationNav"}`}>
                        <SofturaTable
                            data={approvalListAssignement ?? []}
                            columns={approvalHierarchyColumns}
                            sort={false}
                            fixedHeader={true}
                            className="approvalHierarchy-grid"
                            pagination={false}
                            loading={isMyOrdersGridLoading}
                         data-attribute="ComplianceAuditReport_Default_Grid" />
                    </div>
                    <p className="mt-3 mb-2">Hierarchy Modifications</p>
                    <div className={`pe-0 ${complianceModificationReport?.length != 0 ? "softura-table" : "softura-table paginationNav"}`}>
                        <SofturaTable
                            data={complianceModificationReport ?? []}
                            columns={hierarchyModificationColumns}
                            sort={true}
                            defaultPageSize={10}
                            pageSizes={[10, 20, 50]}
                            globalSearch={false}
                            fixedHeader={true}
                            className="approvalHierarchy-grid"
                            isServerSide={false}
                            defaultPaginationPosition='Both'
                            pagination={true}
                            serverTotal={modificationServerTotal}
                            loading={isMyOrdersGridLoading}
                         data-attribute="ComplianceAuditReport_Default_Grid_2" />
                    </div>
                    <p className="mt-3 mb-2">Approver Updates</p>
                    <div className={`pe-0 ${approverUpdatesGridData?.length != 0 ? "softura-table" : "softura-table paginationNav"}`}>
                        <SofturaTable
                            data={approverUpdatesGridData ?? []}
                            columns={hierarchyModificationColumns}
                            sort={true}
                            defaultPageSize={10}
                            pageSizes={[10, 20, 50]}
                            globalSearch={false}
                            fixedHeader={true}
                            className="approvalHierarchy-grid"
                            defaultPaginationPosition='Both'
                            pagination={true}
                            serverTotal={approverUpdateServerTotal}
                            isServerSide={false}
                            loading={isMyOrdersGridLoading}
                         data-attribute="ComplianceAuditReport_Default_Grid_3" />
                    </div>
                </Row>
            </Card>
        </div>
    )
};

export default ComplianceAuditReport;